// extracted by mini-css-extract-plugin
export default {"container":"Textarea-module__container-Egxqjw","label":"Textarea-module__label-E4fuBf","input":"Textarea-module__input-tr8cOn","message":"Textarea-module__message-Lmr0ix"};